// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Ap","textBadge":"e_Bp","buttonBlock":"e_Cp"};